import Swiper  from "swiper";
import {Pagination} from "swiper/modules";
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
Swiper.use([Pagination])

export default class About {
    sliders = [];
    constructor() {
        this.init();
    }

    init() {
        this.initSliders();
        window.addEventListener('resize', () => {
            this.initSliders();
        }, {passive: true})
    }

    initSliders(sliderClass = 'js-about-swiper') {
        if (window.innerWidth > 768) {
            if (this.sliders.length > 0) {
                this.sliders.forEach((v) => {
                    v.destroy();
                });
                this.sliders = []
            }
            return false;
        }
        let sliders = document.querySelectorAll(`.${sliderClass}`);
        if (sliders.length > 0) {
            sliders.forEach((s, ind) => {

                s.classList.add(`about-slider-${ind}`);

                let newSlider = new Swiper(`.about-slider-${ind}`, {
                    loop: true,
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    createElements: true,
                    spaceBetween: 30,
                    pagination: {
                        el: '.swiper-pagination'
                    },
                    breakpoints: {
                        768: {
                            centeredSlides: true,
                            enabled: false,
                            pagination: false,
                        },
                    },
                })

                this.sliders.push(newSlider);
            })
        }
    }
}
